export default {
     imageUrl: "https://api.royalespaces.com",
     baseUrl: "https://api.royalespaces.com",
     // baseUrl: "http://localhost:3001"
};
